/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_Generate_HintInputs */

const en_video_export_preview_generate_hint = /** @type {(inputs: Video_Export_Preview_Generate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click Generate to preview subtitles`)
};

const fr_video_export_preview_generate_hint = /** @type {(inputs: Video_Export_Preview_Generate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliquez sur Generer pour previsualiser les sous-titres`)
};

const de_video_export_preview_generate_hint = /** @type {(inputs: Video_Export_Preview_Generate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klicken Sie auf „Generieren“, um eine Vorschau der Untertitel anzuzeigen.`)
};

const it_video_export_preview_generate_hint = /** @type {(inputs: Video_Export_Preview_Generate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fare clic su Genera per visualizzare l'anteprima dei sottotitoli`)
};

const ru_video_export_preview_generate_hint = /** @type {(inputs: Video_Export_Preview_Generate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нажмите «Создать», чтобы просмотреть субтитры.`)
};

const es_video_export_preview_generate_hint = /** @type {(inputs: Video_Export_Preview_Generate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haga clic en Generar para obtener una vista previa de los subtítulos`)
};

const zh_cn2_video_export_preview_generate_hint = /** @type {(inputs: Video_Export_Preview_Generate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点击“生成”预览字幕。`)
};

const ja_video_export_preview_generate_hint = /** @type {(inputs: Video_Export_Preview_Generate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕をプレビューするには「生成」をクリックします`)
};

const hi_video_export_preview_generate_hint = /** @type {(inputs: Video_Export_Preview_Generate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षकों का पूर्वावलोकन करने के लिए जनरेट पर क्लिक करें`)
};

const pt_pt2_video_export_preview_generate_hint = /** @type {(inputs: Video_Export_Preview_Generate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clique em Gerar para pré-visualizar as legendas.`)
};

/**
* | output |
* | --- |
* | "Click Generate to preview subtitles" |
*
* @param {Video_Export_Preview_Generate_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_generate_hint = /** @type {((inputs?: Video_Export_Preview_Generate_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_Generate_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_preview_generate_hint(inputs)
	if (locale === "de") return de_video_export_preview_generate_hint(inputs)
	if (locale === "it") return it_video_export_preview_generate_hint(inputs)
	if (locale === "ru") return ru_video_export_preview_generate_hint(inputs)
	if (locale === "es") return es_video_export_preview_generate_hint(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_preview_generate_hint(inputs)
	if (locale === "ja") return ja_video_export_preview_generate_hint(inputs)
	if (locale === "hi") return hi_video_export_preview_generate_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_preview_generate_hint(inputs)
	return en_video_export_preview_generate_hint(inputs)
});